import { splitOnMatch } from '@app/studio'
import './matched.css'

/**
 * Text with what was searched for picked out.
 *
 * The split is computed from the LETTERS, because that is how the match was
 * made: a passage may carry vowels the query did not, so searching the displayed
 * string for the query finds nothing the moment a mark sits between two of its
 * letters.
 *
 * One of these for the whole app rather than one per list. A found phrase means
 * the same thing wherever it is found, and two implementations of "show me what
 * matched" is two ways for it to look.
 */
export function Matched({ text, query }: { text: string; query: string }) {
  if (!query.trim()) return <>{text}</>
  /* Each part carries WHERE IT STARTS, which is its identity: the same phrase
     can match twice in one line, so the words alone do not tell two parts apart
     and the position in the array is not a fact about the text. */
  let at = 0
  const parts = splitOnMatch(text, query).map((part) => {
    const from = at
    at += part.text.length
    return { ...part, from }
  })
  return (
    <>
      {parts.map((part) =>
        part.match ? (
          <mark className="matched" key={part.from}>
            {part.text}
          </mark>
        ) : (
          part.text
        ),
      )}
    </>
  )
}
